import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal, ModalController } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-szamlanew',
  templateUrl: './szamlanew.component.html',
  styleUrls: ['./szamlanew.component.scss'],
})
export class SzamlanewComponent implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;
  @Input() csalad: any;

  sajatIntezmeny
  bizonylat = 3

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport

  bizonylattipus = 3;
  bizonylatok = ["-", "számla", "előleg számla", "díjbekérő", "nyugta", "árajánlat", "szállítólevél", "teljesítésigazolás"]

  portControl: FormControl;
  form: FormGroup;
  form2: FormGroup;
  form3: FormGroup;
  formsz: FormGroup;

  tetelek = []
  szamlaprofil;
  loginmode

  constructor(private http: HttpClient, private data: DataService,
    private formBuilder: FormBuilder, private modalController: ModalController) {

  }

  async ngOnInit() {
    this.loginmode = (await this.data.getFromStorage("loginmode"))
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    //this.csalad = (await this.data.getFromStorage("csalad"))
    console.log(this.csalad)
    console.log(this.sajatIntezmeny)
    this.getAllomany();
    this.formsz = this.formBuilder.group({
      sintezmenyname: new FormControl(this.sajatIntezmeny.intezmenyName),
      sorszag: new FormControl("Magyarország"),
      sirsz: new FormControl(this.sajatIntezmeny.irsz),
      stelepules: new FormControl(this.sajatIntezmeny.telepules),
      scim: new FormControl(this.sajatIntezmeny.cim),
      intezmenyName: new FormControl(this.sajatIntezmeny.intezmenyName),
      orszag: new FormControl({ id: 142, nev: "Magyarország" }),
      irsz: new FormControl(this.csalad?.users[0].irsz),
      telepules: new FormControl(this.csalad?.users[0].telepules),
      cim: new FormControl(this.csalad?.users[0].cim),
      teljesites: new FormControl(moment().format("YYYY-MM-DD")),
      kelt: new FormControl(moment().format("YYYY-MM-DD")),
      hatarido: new FormControl(moment().add(8, 'days').format("YYYY-MM-DD")),
      onlinemod: new FormControl("1"),
      account: new FormControl("1"),
      fizmod: new FormControl("3"),
      biztomb: new FormControl("ca6dca3d-fb62-11ef-9adc-0242ac120008"),
      penznem: new FormControl("1"),
      arfolyam: new FormControl("1"),
      nyelv: new FormControl("1"),
      bankszla: new FormControl(),
      kapja: new FormControl(""), //this.csalad.users[0].id
      osszesen: new FormControl(0)
    });
    this.form2.patchValue({ orszag: { id: 142, nev: "Magyarország" } })
    console.log(this.csalad)
  }


  getRowClass = (row) => {
    return {
      'row-color-blue': row.priority == 1,
      'row-color-green': row.priority == 2,
      'row-color-orange': row.priority == 3,
      'row-color-red': row.priority == 4,
    };
  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut() {
    this.http
      .get(
        'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
        {

        }
      )
      .subscribe({
        next: (response) => {
          //this.allomany = response
          console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          /*
          {
              "allapot": "NincsMegFeliratkozva",
              "formatumVerzio": 1,
              "generalva": "0001-01-01T00:00:00",
              "adatok": null,
              "adatAllapot": "OsszeallitasAlatt",
              "leiratkozasOka": "Oktazonvaltozas",
              "leiratkozva": null,
              "letrehozva": null,
              "megtekintveUgyintezokent": false,
              "ugyintezoOktazon": null,
              "isSucceeded": true,
              "reasonOfFail": null,
              "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
              "errorCode": 0,
              "errorCodeString": "0000",
              "time": "2025-01-17T16:35:45.4874766+01:00"
          } */
        },
      });
  }

  getAllomany() {
    this.http
      .get(
        '/api/szamla/intezmenyadatok/' + this.sajatIntezmeny.intezmenyId,
        {}
      )
      .subscribe({
        next: (response) => {
          this.szamlaprofil = response[0]
          if (this.szamlaprofil.bankszamla) this.szamlaprofil.bankszamla = JSON.parse(this.szamlaprofil.bankszamla)
          if (this.szamlaprofil.onlinefiz) this.szamlaprofil.onlinefiz = JSON.parse(this.szamlaprofil.onlinefiz)
          if (this.szamlaprofil.tombok) this.szamlaprofil.tombok = JSON.parse(this.szamlaprofil.tombok)
          console.log(this.szamlaprofil)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    let headers = {
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    this.http
      .get(
        '/api/nyilvantartas/szulo/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allomany = response
          console.log(this.allomany)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/csoport/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.csoport = response
          console.log(this.csoport)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/telepules/hu',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.telepules = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/allampolgarsag',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allampolgar = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/orszagok',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.orszag = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }

  confirm(mode) {
    this.bizonylat = mode
    this.bizonylattipus = mode
  }
  async save() {
    await this.data.showLoading("Mentés...");
    const body = {
      bizonylattipus: this.bizonylattipus,
      tetelek: this.tetelek,
      form: this.formsz.value,
      intezmeny: this.sajatIntezmeny
    }
    this.http
      .post(
        '/api/szamla/create',
        body
      )
      .subscribe({
        next: (response: any) => {
          this.data.hideLoading();
          this.modalController.dismiss();
          this.data.sendToast("Bizonylat létrehozva!", "success")
          this.http
            .get(
              '/api/nav/geninvoice/' + response[0]?.id + '/' + this.sajatIntezmeny.intezmenyId
            )
            .subscribe({
              next: (response2) => {
                this.data.sendToast("Bizonylat generálása sikeres!", "success")
              },
              error: (error) => {
                console.error('Error fetching data:', error);
                //this.modalController.dismiss();
                this.data.sendToast("Hiba történt: " + JSON.stringify(error), "error")
              },
            });
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.hideLoading();
          //this.modalController.dismiss();
          this.data.sendToast("Hiba történt: " + error, "error")
        },
      });
  }
  calculateOsszesen() {
    let v = 0
    this.tetelek.forEach(k => {
      v += k.osszeg
    })
    this.formsz.patchValue({ osszesen: v })
  }

  selectChangedAnyanyelv(e) {

  }

  loadFromEgyenleg() {
    console.log(this.csalad.tetelek)
    this.csalad.tetelek.forEach(g => {
      if ((!g.kapcsolat && g.osszeg < 0 && !g.szamla) || (g.osszeg > 0 && !g.szamla))
        this.tetelek.push({ ...g, afa: 'AAM', mennyiseg: '1', megyseg: 'hó' })
    });
    this.calculateOsszesen()
  }
  addTetel() {
    this.tetelek.push({ "nev": "", "alrendszer": null, osszeg: 0, "afa": "AAM", "mennyiseg": "1", "megyseg": "hó" })
    this.calculateOsszesen()
  }
  deleteTetel(index) {
    this.tetelek.splice(index, 1);
    this.calculateOsszesen()
  }

}
